module.exports = __webpack_public_path__ + "img/lineup-abundance-mercedes-amg.a607675c.jpg";